import { Component, OnInit,ViewChild, TemplateRef } from '@angular/core';
import { DatePipe} from '@angular/common';
import { AveriasService } from "../servicios/averias.service";
import { UntypedFormBuilder } from '@angular/forms';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Column, GridOption, Formatters, AngularGridInstance, Formatter, FieldType, Editors, FileType,} from 'angular-slickgrid';
import { debitos,debitosDTO,seguros, segurosDTO, debitosConsulta } from "../entidades/entidades.component";
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarComponent} from '../snack-bar/snack-bar.component';
import { DateAdapter } from '@angular/material/core';
import {​​ BsModalService, BsModalRef }​​ from 'ngx-bootstrap/modal';
import { DialogoGuardarSeguroComponent } from '../dialogo-guardar-seguro/dialogo-guardar-seguro.component';
import { DialogoGuardarDebitoComponent } from '../dialogo-guardar-debito/dialogo-guardar-debito.component'; 
import { DialogoActualizarSeguroComponent } from '../dialogo-actualizar-seguro/dialogo-actualizar-seguro.component';
import { DialogoActualizarDebitoComponent } from '../dialogo-actualizar-debito/dialogo-actualizar-debito.component';
import { ReparacionesAyudaPopupComponent } from '../reparaciones-ayuda-popup/reparaciones-ayuda-popup.component';
import { ReparacionesAyudaSegurosPopupComponent } from '../reparaciones-ayuda-seguros-popup/reparaciones-ayuda-seguros-popup.component';
import {MatDialog} from '@angular/material/dialog';
import { PerfilesUsuarioService } from '../servicios/perfiles-usuario.service';
import { AnalyticsService } from '../servicios/analytics.service';
//import {SharedModule} from '../shared/shared.module';
import { FormsModule } from '@angular/forms'; // Para [(ngModel)]
import { DropdownModule } from 'primeng/dropdown'; // Para <p-dropdown>
import { NbIconModule } from '@nebular/theme'; // Para <nb-icon>
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../spinner/spinner.component';
import { NbCardModule } from '@nebular/theme';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { NbTabsetModule } from '@nebular/theme';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; // necesario para el datepicker
import { NbSelectModule } from '@nebular/theme';

import { AgGridAngular } from 'ag-grid-angular'; // Angular Data Grid Component
import type { ColDef } from 'ag-grid-community'; // Column Definition Type Interface
import { GridApi, GridReadyEvent } from 'ag-grid-community';

import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver'; 

@Component({
    selector: 'app-reparaciones',
    templateUrl: './reparaciones.component.html',
    styleUrls: ['./reparaciones.component.css'],
    providers: [
        DatePipe,
        { provide: MatFormFieldControl, useExisting: ReparacionesComponent }
    ],
    standalone: true,
    imports: [NbSelectModule,MatDatepickerModule,MatNativeDateModule, FormsModule,
      CommonModule,NbCardModule,NbIconModule,DropdownModule,MatCardModule,
      MatFormFieldModule,MatInputModule,AngularSlickgridModule,NbTabsetModule,SpinnerComponent,
    AgGridAngular],
})
export class ReparacionesComponent implements OnInit {
  idCliente:number;
  misDebitos: debitos[] = [];
  misSeguros: seguros[] = [];
  meta;
  misDebitosGuardados= [];
  misSegurosGuardados= [];
  operador;
  IdOperador : number;
  operadorProcesadoSeguros = 0;
  operadorProcesadoDebitos = 0;
  cargarGrillaDebitos = false;
  cargarGrillaSeguros = false;
  deshabilitarExportDeb = true;
  deshabilitarExportSeg = true;
  loadingResponse = false;
  showSpinner = false;
  showSpinnerGuardarDebito = false;
  showSpinnerGuardarSeguro = false;
  gridOptionsReparacionesDebitos: GridOption;
  columnDefinitionsReparacionesDebitos: ColDef[];//Column[];
  columnDefinitionsReparacionesSeguros: ColDef[];//Column[];
  datasetReparacionesDebitos: any[] = [];
  angularGridDebitos: AngularGridInstance;
  dataViewDebitos: any;
  gridObjDebitos: any;
  dataViewSeguros: any;
  gridObjSeguros: any;
  gridOptionsReparacionesSeguros: GridOption;
  columnDefinitionsReparacionesSeguross: ColDef[];//Column[];
  datasetReparacionesSeguros: any[] = [];
  angularGridSeguros: AngularGridInstance;
  // updatedObjectDebitos: any;
  // arrCambiosDebito: Array<any> = [];
  // updatedObjectSeguros: any;
  // arrCambiosSeguros: Array<any> = [];
  durationInSeconds = 5;
  dataGuardarSeguros: string[] = [];
  deshabilitarBuscarDebito = true;
  deshabilitarBuscarSeguro = true;

  deshabilitarGuardarDebito = true;
  deshabilitarGuardarSeguro = true;

  deshabilitarActualizarDebito = true;
  deshabilitarActualizarSeguro = true;

  desdeDebito= new Date();
  hastaDebito= new Date();
  desdeSeguro= new Date();
  hastaSeguro= new Date();

  desdeDebitoS= "";
  hastaDebitoS= "";
  desdeSeguroS= "";
  hastaSeguroS="";

  showGrilla = false;

  modalRef: BsModalRef;

  @ViewChild('grilla1') grilla1!: AgGridAngular;
  @ViewChild('grilla2') grilla2!: AgGridAngular;
  @ViewChild('grilla3') grilla3!: AgGridAngular;

  constructor(private servicioAverias: AveriasService, private adapter: DateAdapter<any> ,
    private dateFormatter: DatePipe, private fb: UntypedFormBuilder, private _snackBar: MatSnackBar,
    private modalService: BsModalService, public dialog: MatDialog, public usersRol: PerfilesUsuarioService, 
    private svcAnalytics: AnalyticsService) { }

  ngOnInit(): void {
    this.idCliente = Number(localStorage.getItem("idCliente"));
    this.adapter.setLocale('es-MX');
    this.consultarOperadores();
    this.desdeDebitoS = this.dateFormatter.transform(this.desdeDebito, "yyyy-MM-dd");
    this.hastaDebitoS = this.dateFormatter.transform(this.hastaDebito, "yyyy-MM-dd");
    this.desdeSeguroS = this.dateFormatter.transform(this.desdeSeguro, "yyyy-MM-dd");
    this.hastaSeguroS = this.dateFormatter.transform(this.hastaSeguro, "yyyy-MM-dd");
    this.svcAnalytics.setAnalyticsPageView();
  }
  openSnackBar(mensaje: string) {
    this._snackBar.openFromComponent(SnackBarComponent, {
      duration: this.durationInSeconds * 1000,
      data: mensaje
    });
  }


  changeDesdeDebito(event: any) {
    this.desdeDebito = event;
    this.desdeDebitoS = this.dateFormatter.transform(this.desdeDebito, "yyyy-MM-dd");
  }
  changeHastaDebito(event: any) {
    this.hastaDebito = event;
    this.hastaDebitoS = this.dateFormatter.transform(this.hastaDebito, "yyyy-MM-dd");
  }
  changeDesdeSeguro(event: any) {
    this.desdeSeguro = event;
    this.desdeSeguroS = this.dateFormatter.transform(this.desdeSeguro, "yyyy-MM-dd");
  }
  changeHastaSeguro(event: any) {
    this.hastaSeguro = event;
    this.hastaSeguroS = this.dateFormatter.transform(this.hastaSeguro, "yyyy-MM-dd");
  }
  consultarOperadores() {
    this.servicioAverias.getOperadoresPorCliente(this.idCliente).subscribe(
      data => {
        this.operador = data;
    });
  }

  traerDatosDebitos(){
    let filtro;
    this.showSpinner = true;
    this.cargarGrillaDebitos = false;
    // this.bloqueoGenerar = true;
    // this.deshabilitarExportAverias = true;
    filtro = {
      receptor: [],
      cedente: [],
      idCliente: this.idCliente,
      fechaDesdeInspeccion: this.dateFormatter.transform(this.desdeDebito, "yyyy-MM-ddT") + "00:00:00",
      fechaHastaInspeccion: this.dateFormatter.transform(this.hastaDebito, "yyyy-MM-ddT") + "23:59:00",
      responsable: [this.operadorProcesadoDebitos],
      proceso: null,
      vin: null,
      transporte: null,

    }
    if(this.desdeDebito <= this.hastaDebito){

      this.servicioAverias.getAverias(filtro).subscribe( data => {
        if(data["status"]==200){
          
          this.showSpinner = false;
          this.showGrilla = true;
          if (data.body.length > 0) {
            let mockDataset: any = [];
            for (let i = 0; i < data.body.length; i++) {
              mockDataset.push({
                areaComponente: data.body[i].areaComponente,
                fecha: data.body[i].fecha,
                fechaAlta: data.body[i].fechaAlta,
                fechaUltimaMod: data.body[i].fechaUltimaMod,
                id: data.body[i].id,
                idAreaComponente:data.body[i].idAreaComponente,
                idResponsable: data.body[i].idResponsable,
                idSeveridad: data.body[i].idSeveridad,
                idTipoAveria: data.body[i].idTipoAveria,
                idZonaCuadranteDetalle: data.body[i].idZonaCuadranteDetalle,
                observacion: data.body[i].observacion,
                proceso: data.body[i].proceso,
                responsable: data.body[i].responsable,
                severidad: data.body[i].severidad,
                tipoAveria: data.body[i].tipoAveria,
                usuarioAlta: data.body[i].usuarioAlta,
                usuarioUltimaMod: data.body[i].usuarioUltimaMod,
                vin: data.body[i].vin,
                zonaCuadranteDetalle: data.body[i].zonaCuadranteDetalle,
                modelo: data.body[i].modelo,
                clasificacion: "Sin Datos",
                debito: data.body[i].okDebito,
                pago: data.body[i].okPago,
                // seguro: data.body[i].okSeguro
              });
            }
            this.datasetReparacionesDebitos = mockDataset;
            this.showSpinner = false;
            this.cargarGrillaDebitos = true;
            if (this.datasetReparacionesDebitos.length > 0){
              this.deshabilitarExportDeb = false;
            }

          } else {
            this.openSnackBar("No existen registros para la busqueda realizada");
            this.showGrilla = false;
          }
          
        }
      else if(data["status"]==403){
        this.openSnackBar(data["errors"][0].message)
      }else{
        this.openSnackBar("Ocurrio un error al guardar los datos");
      }
    }
    ,erros => {
      this.showSpinner = false;
      this.cargarGrillaDebitos = true;
    }
    )
    } 
     else {
     this.openSnackBar("Seleccione rango de fecha válido");
     this.showSpinner = false
     }
  }

  buscarDebitos(){
    if (this.operadorProcesadoDebitos == 0){
      this.openSnackBar("Debe seleccionar un Operador!");
    }
    else{
      this.deshabilitarExportDeb = true;
      this.fillGrillaDebitos();
    }
  }
  buscarSeguros(){
    if (this.operadorProcesadoSeguros == 0){
      this.openSnackBar("Debe seleccionar un Operador!");
    }
    else{
      this.deshabilitarExportSeg = true;
      this.fillGrillaSeguros();
       //gtag busqueda
       this.svcAnalytics.setAnalyticsSearchButton();
    }
  }
  fillGrillaDebitos() {
    this.columnDefinitionsReparacionesDebitos = [
      { //id: 'modelo', 
        headerName: 'Modelo', field: 'modelo', sortable: true, filter: true, floatingFilter: true, minWidth: 100,},
      { //id: 'vin', 
        headerName: 'Vin', field: 'vin', sortable: true, filter: true, floatingFilter: true, minWidth: 120},
      { //id: 'clasificacion', 
        headerName: 'Clasificación', field: 'clasificacion', sortable: true, filter: true, floatingFilter: true, minWidth: 120},
      { //id: 'areaComponente', 
        headerName: 'Área', field: 'areaComponente', sortable: true, filter: true, floatingFilter: true, minWidth: 165},
      { //id: 'tipoAveria', 
        headerName: 'Tipo Avería', field: 'tipoAveria', sortable: true, filter: true, floatingFilter: true, minWidth: 100},
      { //id: 'severidad', 
        headerName: 'Severidad', field: 'severidad', sortable: true, filter: true, floatingFilter: true, minWidth: 110},
      { //id: 'idAreaComponente', 
        headerName: 'Cod Area', field: 'idAreaComponente', sortable: true, filter: true, floatingFilter: true, minWidth: 90},
      { //id: 'idTipoAveria', 
        headerName: 'Cod Tipo Averia', field: 'idTipoAveria', sortable: true, filter: true, floatingFilter: true, minWidth: 120},
      { //id: 'idSeveridad', 
        headerName: 'Cod Severidad', field: 'idSeveridad', sortable: true, filter: true, floatingFilter: true, minWidth: 110},
      { //id: 'debito', 
        headerName: 'Debito', field: 'debito',  minWidth: 40,
      sortable: true,
      filter: true,
      //formatter: Formatters.multiple,
      //params: { formatters: [Formatters.complexObject, Formatters.checkmark] },
      type: FieldType.boolean, 
      editable: true,
      cellRenderer: 'agCheckboxCellRenderer', // muestra checkbox

      //editor: { model: Editors.checkbox }
      },
      { //id: 'pago', 
        headerName: 'Pago', field: 'pago', minWidth: 40,
      sortable: true,
      filter: true,
      editable: true,
      cellRenderer: 'agCheckboxCellRenderer', // muestra checkbox

      //formatter: Formatters.multiple,
      //params: { formatters: [Formatters.complexObject, Formatters.checkmark] },
      type: FieldType.boolean, 
      //editor: { model: Editors.checkbox }
      },
    ];
    this.gridOptionsReparacionesDebitos = {
      enableExcelExport: true,
      enableAutoResize: true,
      enableGridMenu : false,
      //enableExport: true,
      enableSorting: true,
      enableCellNavigation: true,
      enableCellMenu: true,
      enableFiltering: true,
      enablePagination: false,
      editable: false,
      enableAsyncPostRender: true, // for the Angular PostRenderer, don't forget to enable it
      asyncPostRenderDelay: 0,    // also make sure to remove any delay to render it
    };

    this.traerDatosDebitos();
    //gtag busqueda
    this.svcAnalytics.setAnalyticsSearchButton();
  }
  angularGridReadyDebitos(angularGrid: AngularGridInstance){
    this.angularGridDebitos = angularGrid;
    this.dataViewDebitos = angularGrid.dataView;
    this.gridObjDebitos = angularGrid.slickGrid 
  }

  exportToExcelDebitos() {
    // (this.angularGridDebitos as any).excelExportService.exportToExcel({
    //   filename: 'Debitos',
    //   format: FileType.xlsx
    // });
    // //gtag excel
    this.exportToExcelDebitosexpo();
    this.svcAnalytics.setAnalyticsExcelButton();
  }

  traerDatosSeguros(){
    let filtro;
    this.showSpinner= true;
    this.cargarGrillaSeguros = false;
    // this.bloqueoGenerar = true;
    // this.deshabilitarExportAverias = true;
    filtro = {
      receptor: [],
      cedente: [],
      idCliente: this.idCliente,
      fechaDesdeInspeccion: this.dateFormatter.transform(this.desdeSeguro, "yyyy-MM-ddT") + "00:00:00",
      fechaHastaInspeccion: this.dateFormatter.transform(this.hastaSeguro, "yyyy-MM-ddT") + "23:59:00",
      responsable: [this.operadorProcesadoSeguros],
      proceso: null,
      vin: null,
      transporte: null,

    }
    if(this.desdeSeguro <= this.hastaSeguro){

      this.servicioAverias.getAverias(filtro).subscribe( data => {
        if(data["status"]==200){
          this.showSpinner = false;
          this.showGrilla = true;
          if (data.body.length > 0) {
            let mockDataset: any = [];
            for (let i = 0; i < data.body.length; i++) {
              mockDataset.push({
                areaComponente: data.body[i].areaComponente,
                fecha: data.body[i].fecha,
                fechaAlta: data.body[i].fechaAlta,
                fechaUltimaMod: data.body[i].fechaUltimaMod,
                id: data.body[i].id,
                idAreaComponente:data.body[i].idAreaComponente,
                idResponsable: data.body[i].idResponsable,
                idSeveridad: data.body[i].idSeveridad,
                idTipoAveria: data.body[i].idTipoAveria,
                idZonaCuadranteDetalle: data.body[i].idZonaCuadranteDetalle,
                observacion: data.body[i].observacion,
                proceso: data.body[i].proceso,
                responsable: data.body[i].responsable,
                severidad: data.body[i].severidad,
                tipoAveria: data.body[i].tipoAveria,
                usuarioAlta: data.body[i].usuarioAlta,
                usuarioUltimaMod: data.body[i].usuarioUltimaMod,
                vin: data.body[i].vin,
                zonaCuadranteDetalle: data.body[i].zonaCuadranteDetalle,
                modelo: data.body[i].modelo,
                clasificacion: "Sin Datos",
                debito: data.body[i].okDebito,
                pago: data.body[i].okPago,
                seguro: data.body[i].okSeguro
              });
            }
            this.datasetReparacionesSeguros = mockDataset;
            this.showSpinner = false;
            this.cargarGrillaSeguros = true;
            if (this.datasetReparacionesSeguros.length > 0){
              this.deshabilitarExportSeg = false;
            }

          } else {
            this.openSnackBar("No existen registros para la busqueda realizada");
            this.showGrilla = false;
          }
          
        }
      else if(data["status"]==403){
        this.openSnackBar(data["errors"][0].message)
      }else{
        this.openSnackBar("Ocurrio un error al guardar los datos");
      }
    }
    ,erros => {
      this.showSpinner = false;
      this.cargarGrillaSeguros = true;
    }
    )
    } 
     else {
     this.openSnackBar("Seleccione rango de fecha válido");
     this.showSpinner = false
     }
  }

  fillGrillaSeguros() {
    this.columnDefinitionsReparacionesSeguros = [
      { //id: 'modelo', 
        headerName: 'Modelo', field: 'modelo', sortable: true, filter: true, floatingFilter: true, minWidth: 100,},
      { //id: 'vin', 
        headerName: 'Vin', field: 'vin', sortable: true, filter: true, floatingFilter: true, minWidth: 120},
      { //id: 'clasificacion', 
        headerName: 'Clasificación', field: 'clasificacion', sortable: true, filter: true, floatingFilter: true, minWidth: 120},
      { //id: 'areaComponente', 
        headerName: 'Área', field: 'areaComponente', sortable: true, filter: true, floatingFilter: true, minWidth: 165},
      { //id: 'tipoAveria', 
        headerName: 'Tipo Avería', field: 'tipoAveria', sortable: true, filter: true, floatingFilter: true, minWidth: 100},
      { //id: 'severidad', 
        headerName: 'Severidad', field: 'severidad', sortable: true, filter: true, floatingFilter: true, minWidth: 110},
      { //id: 'idAreaComponente', 
        headerName: 'Cod Area', field: 'idAreaComponente', sortable: true, filter: true, floatingFilter: true, minWidth: 100},
      { //id: 'idTipoAveria', 
        headerName: 'Cod Tipo Averia', field: 'idTipoAveria', sortable: true, filter: true, floatingFilter: true, minWidth: 120},
      { //id: 'idSeveridad', 
        headerName: 'Cod Severidad', field: 'idSeveridad', sortable: true, filter: true, floatingFilter: true, minWidth: 110},
      
      { //id: 'seguro', 
        headerName: 'Ok seguro', 
        field: 'seguro', 
        sortable: true, 
        filter: true, 
        //floatingFilter: true, 
        minWidth: 40,
        ///formatter: Formatters.multiple,
        //params: { formatters: [Formatters.complexObject, Formatters.checkmark] },
        type: FieldType.boolean, 
        editable: true,
        cellRenderer: 'agCheckboxCellRenderer', // muestra checkbox

      //editor: { model: Editors.checkbox },
       // excludeFromExport: true
      }
    ];
    this.gridOptionsReparacionesSeguros = {
      enableExcelExport: true,
      enableAutoResize: true,
      enableGridMenu : false,
      enableSorting: true,
      enableCellNavigation: true,
      enableCellMenu: true,
      enableFiltering: true,
      enablePagination: false,
      editable: true,
    };
    this.traerDatosSeguros();
  }
  angularGridReadySeguros(angularGrid: AngularGridInstance){
    this.angularGridSeguros = angularGrid;
    this.dataViewSeguros = angularGrid.dataView;
    this.gridObjSeguros =  angularGrid.slickGrid
  }  

  exportToExcelSeguros() {
    // (this.angularGridSeguros as any).excelExportService.exportToExcel({
    //   filename: 'Seguros',
    //   format: FileType.xlsx
    // });
    this.exportToExcelSegurosexpo();
    this.svcAnalytics.setAnalyticsExcelButton();
  }

  guardarSeguros(){
    var objSeguros: segurosDTO;
    var objSaveSeguros: segurosDTO[]=[];
    this.misSegurosGuardados.forEach(element => {
      objSeguros = {
        idVinAverias: element.id,
        okDebito: null,
        okPago: null,
        okSeguro: element.seguro,
      }
      objSaveSeguros.push(objSeguros);
    });
    this.servicioAverias.actualizarDebitosPagosSeguros(objSaveSeguros).subscribe( data=> {
    if(data["status"] == 200){
      this.openSnackBar('Los cambios se han guardado correctamente');
       this.misSegurosGuardados = [];
       } else {
        this.openSnackBar('Ha ocurrido un error al guardarse los datos');
      }
     this.deshabilitarGuardarSeguro = true;
        this.showSpinnerGuardarSeguro = false;
        this.misSegurosGuardados = [];
    }, errors => {
        this.showSpinnerGuardarSeguro = false;
        this.misSegurosGuardados = [];
    })
  }
  guardarDebitos(){
    var objDebitos: debitosDTO;
    var objSaveDebitos: debitosDTO[]=[];
    this.misDebitosGuardados.forEach(element => {
      objDebitos = {
        // id: element.id,
        idVinAverias: element.id,
        okDebito: element.debito,
        okPago: element.pago,
        okSeguro: null
      }
      objSaveDebitos.push(objDebitos);
    });
    this.servicioAverias.actualizarDebitosPagosSeguros(objSaveDebitos).subscribe( data=> {
    if(data["status"] == 200){
       this.openSnackBar('Los cambios se han guardado correctamente');
       this.misDebitosGuardados = [];
       } else {
        this.openSnackBar('Ha ocurrido un error al guardarse los datos');
      }
     this.deshabilitarGuardarDebito = true;
     this.showSpinnerGuardarDebito = false;
     this.misDebitosGuardados = [];
    }, errors => {
      this.deshabilitarGuardarDebito = true;
      this.showSpinnerGuardarDebito = false;
      this.misDebitosGuardados = [];
    })
  }
  
  openGuardarDebito() {
    if(this.misDebitosGuardados.length==0){
      this.openSnackBar("Debe editar un registro antes de guardar!");
    }else{
    const dialogRef = this.dialog.open(DialogoGuardarDebitoComponent, {
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.deshabilitarActualizarDebito= false;  
        this.deshabilitarGuardarDebito = true;
        this.showSpinnerGuardarDebito = true;      
        this.guardarDebitos();
        //gtag alta
        this.svcAnalytics.setAnalyticsAltaButton();
      }
      else
        this.deshabilitarActualizarDebito=true;
    });}
  }
  openGuardarSeguros() {
    if(this.misSegurosGuardados.length==0){
      this.openSnackBar("Debe editar un registro antes de guardar!");
    }else{
    const dialogRef = this.dialog.open(DialogoGuardarSeguroComponent, {
    });
    dialogRef.afterClosed().subscribe(result => {
    if(result){
      this.deshabilitarActualizarSeguro= false;
      this.deshabilitarGuardarSeguro = true; 
      this.showSpinnerGuardarSeguro = true;
      this.guardarSeguros(); 
      //gtag alta
      this.svcAnalytics.setAnalyticsAltaButton();
    }
    else
      this.deshabilitarActualizarSeguro=true;
    });}
  }
  openActualizarDebitos(): void {
    const dialogRef = this.dialog.open(DialogoActualizarDebitoComponent, {
      data: {actualizo: false}
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result) {
        this.deshabilitarActualizarDebito= true;
        this.buscarDebitos();
      }
    });
  }  
  openActualizarSeguros(): void {
    const dialogRef = this.dialog.open(DialogoActualizarSeguroComponent, {
      data: {actualizo: false}
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result) {
        this.deshabilitarActualizarSeguro= true;
        this.buscarSeguros();
      }
    });
  }

  
  capturarOperadorDebitos(){
    if(this.operadorProcesadoDebitos !=0)
      this.deshabilitarBuscarDebito = false;
  }
  capturarOperadorSeguros(){
    if(this.operadorProcesadoSeguros !=0)
      this.deshabilitarBuscarSeguro = false;
  }
  onCellClickedDebitos(e, args) {
    var metadata = this.angularGridDebitos.gridService.getColumnFromEventArguments(args);
    if (metadata.columnDef.id === 'debito') {
      this.onCellChangedDebitosNEW(metadata,'debito');
    }
    if (metadata.columnDef.id === 'pago') {
      this.onCellChangedDebitosNEW(metadata,'pago');
    } 
  }

  onCellClickedSeguros(e, args) {
    var metadata = this.angularGridDebitos.gridService.getColumnFromEventArguments(args);
    if (metadata.columnDef.id === 'seguro') {
      this.onCellChangedSegurosNEW(metadata,'seguro');
    }
  }

  onCellChangedDebitosNEW(any,celda: string) {
    this.deshabilitarGuardarDebito = false;
    if (celda == 'debito'){
      any["dataContext"].debito =  any["dataContext"].debito== true ? false : true;
    }
    if (celda == 'pago'){
      any["dataContext"].pago =  any["dataContext"].pago== true ? false : true;
    }
    this.misDebitosGuardados.push({id: any["dataContext"].id, debito:any["dataContext"].debito, pago: any["dataContext"].pago})
    this.angularGridDebitos.slickGrid.invalidateRow(any.row);
    this.angularGridDebitos.slickGrid.render();
  }  

  onCellChangedSegurosNEW(any,celda: string) {
    this.deshabilitarGuardarSeguro = false;
    if (celda == 'seguro'){
      any["dataContext"].seguro =  any["dataContext"].seguro== true ? false : true;
    }
    this.misSegurosGuardados.push({id: any["dataContext"].id, seguro: any["dataContext"].seguro})
    this.angularGridSeguros.slickGrid.invalidateRow(any.row);
    this.angularGridSeguros.slickGrid.render();
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(ReparacionesAyudaPopupComponent, {
      width: '600px', height: '400px'
    });
  }

  openDialogSeguros(): void {
    const dialogRef = this.dialog.open(ReparacionesAyudaSegurosPopupComponent, {
      width: '600px', height: '400px'
    });
  }

    exportToExcelDebitosexpo(): void {
        const rowData: any[] = [];
       const columnasVisibles = this.grilla1.api.getAllDisplayedColumns();
      
        // Obtener solo las filas visibles (después de filtros y orden)
        this.grilla1.api.forEachNodeAfterFilterAndSort((node) => {
          if (node.data) {
            const filaFiltrada: any = {};
      
            // Solo columnas visibles
            columnasVisibles.forEach(col => {
              const campo = col.getColDef().field;
              if (campo && campo!='action') {
                filaFiltrada[campo] = node.data[campo];
              }
            });
            rowData.push(filaFiltrada);
          }
        });
      
        if (rowData.length === 0) {
          console.warn('No hay datos para exportar');
          return;
        }
      
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(rowData);
        const workbook: XLSX.WorkBook = {
          Sheets: { 'Debitos': worksheet },
          SheetNames: ['Debitos']
        };
      
        const excelBuffer: any = XLSX.write(workbook, {
          bookType: 'xlsx',
          type: 'array'
        });
      
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        FileSaver.saveAs(blob, 'Debitos_' + this.dateFormatter.transform(new Date(), 'dd-MM-yyyy') + '.xlsx');
      }


  exportToExcelSegurosexpo(): void {
        const rowData: any[] = [];
       const columnasVisibles = this.grilla2.api.getAllDisplayedColumns();
      
        // Obtener solo las filas visibles (después de filtros y orden)
        this.grilla2.api.forEachNodeAfterFilterAndSort((node) => {
          if (node.data) {
            const filaFiltrada: any = {};
      
            // Solo columnas visibles
            columnasVisibles.forEach(col => {
              const campo = col.getColDef().field;
              if (campo && campo!='action') {
                filaFiltrada[campo] = node.data[campo];
              }
            });
            rowData.push(filaFiltrada);
          }
        });
      
        if (rowData.length === 0) {
          console.warn('No hay datos para exportar');
          return;
        }
      
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(rowData);
        const workbook: XLSX.WorkBook = {
          Sheets: { 'Seguros_': worksheet },
          SheetNames: ['Seguros_']
        };
      
        const excelBuffer: any = XLSX.write(workbook, {
          bookType: 'xlsx',
          type: 'array'
        });
      
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        FileSaver.saveAs(blob, 'Seguros_' + this.dateFormatter.transform(new Date(), 'dd-MM-yyyy') + '.xlsx');
      }

    onGridReady(params: GridReadyEvent): void {
    this.grilla1.api.sizeColumnsToFit();
    this.grilla2.api.sizeColumnsToFit();
    this.grilla3.api.sizeColumnsToFit();
  
  }

}